import { useTranslation } from 'react-i18next';

import { TFileValidationError } from '@/shared/components/ui/form/components/file-dropzone/hooks/use-file-validator/use-file-validator.types';

export const FILE_TYPE_NOT_SUPPORTED_ERROR_CODE = 'extension-not-allowed';

export const useFileValidator = (acceptedFileTypes: string[] = []) => {
  const { t } = useTranslation();

  const validateFileExtension = (file: File): TFileValidationError | null => {
    if (acceptedFileTypes.length === 0) {
      return null;
    }

    if (acceptedFileTypes.includes('*')) {
      return null;
    }

    const fileName = file.name;
    const fileExtension = fileName.split('.').pop()?.toLowerCase();
    const extensionAllowed = acceptedFileTypes?.some(
      (type) =>
        type.toLowerCase() === fileExtension ||
        type.toLowerCase() === `.${fileExtension}`,
    );

    if (!extensionAllowed) {
      return {
        code: FILE_TYPE_NOT_SUPPORTED_ERROR_CODE,
        message: t('ui:file_extension_not_allowed'),
      };
    }

    return null;
  };

  return validateFileExtension;
};
